import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IRowData } from '../../../../../models/list-models';
import { IDropdownOption } from '../../../../../typings/interfaces/design-library.interface';

@Component({
  selector: 'shelter-portfolio-permission-dropdown',
  template: require('./shelter-portfolio-permission-dropdown.component.html'),
})
export class ShelterPortfolioPermissionDropdownComponent implements OnInit {
  selected: string; // the key of selected option
  plainText: string; // the human of selected option
  options: IDropdownOption[] = [{ key: 'Can view', human: 'Can view' }, { key: 'No access', human: 'No access' }];
  public mode: 'DROPDOWN_MODE' | 'TEXT_MODE';
  @Input() trigger: null | boolean = null;
  @Input() input: { row: IRowData[]; column: IRowData };
  @Output() output = new EventEmitter();

  ngOnInit() {
    const { row } = this.input;
    const permissionCol = row.find((v: IRowData) => v.columnKey === 'SHELTER_PERMISSION');
    const human = permissionCol.data;
    this.selected = human;
    this.plainText = human;
    this.mode = this.trigger ? 'DROPDOWN_MODE' : 'TEXT_MODE';
  }

  public onSelect(e): void {
    const { row } = this.input;
    this.output.emit({ selectedKey: e, row });
  }
}
